import { buildHtmlElement } from '@/js/util/build_html_element';
import { appFor } from '@/js/util/tiptap/extensions/_get_menu_control';
import DfApi from '@/js/modules/df_api';
import confirmDialog from '@/js/modules/confirm_dialog';
const api = () => new DfApi();

const notFoundError = (_response) => {
  alert('Preset not found');
};

const emptyNameError = () => {
  alert('You need to provide a non-empty name');
};

const kindOfPreset = (editor) => {
  const app = appFor(editor);
  const variant = app.dataset.tiptapEditorVariantValue;

  return {
    standard: 'contract',
    invoice_notes: 'invoice',
    quote_notes: 'quote',
    quote_terms: 'quote_approval_terms',
    retainer_notes: 'retainer',
    design_rationale: 'rationale',
    purchase_order_notes: 'purchase_order',
    spec_sheet_notes: 'spec_sheet',
  }[variant];
};

const creationSuccess = async (response, editor) => {
  const { id, title } = await response.json();
  const substitutions = { id, title };
  const presetsCollection = appFor(editor).querySelector('.presets__collection');

  if (presetsCollection) {
    const presetGroup = buildHtmlElement('preset-menu-control', substitutions);
    presetsCollection.appendChild(presetGroup);
  }
};

const creationError = (response, name) => {
  alert(`An error occurred while creating preset ${name}`);
};

const createPreset = async (editor, name) => {
  const details = editor.getHTML();
  const presetKind = kindOfPreset(editor);
  const projectId = appFor(editor).dataset.tiptapEditorProjectId;
  const response = await api().createPreset(name, presetKind, projectId, details);

  response.ok ? creationSuccess(response, editor) : creationError(response, name);
};

const writePresetToEditor = async (response, editor) => {
  const { details } = await response.json();
  editor.commands.setContent(details, true);
};

const loadPreset = async (editor, button) => {
  const presetId = button.value;
  const app = appFor(editor);
  const projectId = app.dataset.tiptapEditorProjectId;
  const contractId = app.dataset.tiptapEditorContractId;
  const response = await api().getPreset(presetId, projectId, contractId);

  response.ok ? writePresetToEditor(response, editor) : notFoundError(response);
};

const savePreset = (editor, button) => {
  const name = prompt('Enter a template name');

  if (name === null) {
    return;
  }

  const emptyName = name.trim().length === 0;

  emptyName ? emptyNameError() : createPreset(editor, name);
};

const deletePreset = async (editor, button) => {
  const remove = await confirmDialog(`Do you want to delete ${button.dataset.name}?`, {
    button: 'Delete',
  });

  if (remove) {
    const presetId = button.value;
    const response = await api().deletePreset(presetId);

    response.ok ? button.parentElement.remove() : notFoundError(response);
  }
};

const presetHandlers = {
  'preset:load': loadPreset,
  'preset:save': savePreset,
  'preset:delete': deletePreset,
};

export default presetHandlers;
